import React from "react";
import IntlMessages from "@util/IntlMessages";
import ListSettings from "./ListSettings";
import ListMapSettings from "./ListMapSettings";
import ListWidgetSettings from "./ListWidgetSettings";
import ListFilteringSettings from "./ListFilteringSettings";
import ListChatSettings from "./ListChatSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import ListUrlSettings from "./ListUrlSettings";

const ListTabs = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="1">
            <ListWidgetSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.listSettings" />} key="2">
            <ListSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.mapSettings" />} key="3">
            <ListMapSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.listFilteringSettings" />} key="4">
            <ListFilteringSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="Chat Settings" />} key="5">
            <ListChatSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="Url Settings" />} key="6">
            <ListUrlSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default ListTabs;
